import { HssItem } from "./hss-item";

export class HssLeg {
  index: number;
  dpIndex: number = -1;
  dutyPeriod = new HssItem("DutyPeriod");
  schedEquipCode = new HssItem("ScheduledEquipmentNumCo");
  actualEquipCode = new HssItem("ActualEquipmentNumCo");
  fltNum = new HssItem("FlightNumber");
  depStation = new HssItem("DepartureStation");
  fltOriginDate = new HssItem("FltOriginDate");
  depTimeSched = new HssItem("DepartureTimeSched");
  depTimeSchedLocal = new HssItem("DepartureTimeSchedLocal");
  isDepTimeSched = new HssItem("DepartureTimeSchedSpecified");
  depTimeReSched = new HssItem("DepartureTimeReSched");
  depTimeReSchedLocal = new HssItem("DepartureTimeReSchedLocal");
  isDepTimeReSched = new HssItem("DepartureTimeReSchedSpecified");
  depTimeActual = new HssItem("DepartureTimeActual");
  depTimeActualLocal = new HssItem("DepartureTimeActualLocal");
  isDepTimeActual = new HssItem("DepartureTimeActualSpecified");
  depTimeIsEstimated = new HssItem("DepEstimated");
  meal = new HssItem("MealIndicator");
  arrStation = new HssItem("ArrivalStation");
  arrTimeSched = new HssItem("ArrivalTimeSched");
  arrTimeSchedLocal = new HssItem("ArrivalTimeSchedLocal");
  isArrTimeSched = new HssItem("ArrivalTimeSchedSpecified");
  arrTimeReSched = new HssItem("ArrivalTimeReSched");
  arrTimeReSchedLocal = new HssItem("ArrivalTimeReSchedLocal");
  isArrTimeReSched = new HssItem("ArrivalTimeReSchedSpecified");
  arrTimeActual = new HssItem("ArrivalTimeActual");
  arrTimeActualLocal = new HssItem("ArrivalTimeActualLocal");
  isArrTimeActual = new HssItem("ArrivalTimeActualSpecified");
  arrTimeIsEstimated = new HssItem("ArrEstimated");
  addCode = new HssItem("LegAssignmentCode");
  removalCode = new HssItem("LegRemovalCode");
  greaterTime = new HssItem("GreaterTime");
  groundTimeSched = new HssItem(null);
  groundTimeReSched = new HssItem(null);
  groundTimeActual = new HssItem(null);
  actualTime = new HssItem(null);
  diversionTime = new HssItem("DiversionTime");
  atcDelayMinutes = new HssItem("DelayMinutesATC");
  deicingDelayMinutes = new HssItem("DelayMinutesDeIcing");
  rampDelayMinutes = new HssItem("DelayMinutesRamp");
  oalSurfaceAirline = new HssItem("OALSurfaceAirline"); // Other airline DH code
  seatActual = new HssItem("SeatActual");
  // Boolean flags
  isDiversion = new HssItem("Diversion");
  isDiversionContinuation = new HssItem("DiversionContinuation");
  isActive = new HssItem("Active");
  isCancelled = new HssItem("Cancelled");
  isAirInterrupt = new HssItem("AirInterrupt");
  isGroundInterrupt = new HssItem("GrndInterrupt");
  isStub = new HssItem("Stub");
  isDpStart = new HssItem("DPStart");
  isDpEnd = new HssItem("DPEnd");
  isSeqEnd = new HssItem("SeqEnd");
  isDhNoShow = new HssItem("IsDhNoShowLeg");
  isDhTypeA1 = new HssItem("DHTypeA1");
  isDhOrSurface = new HssItem("DHorSurface");
  isOalDh = new HssItem("OALDH");
  isNextLegFailedContinuity = new HssItem("NextLegFailedContinuity");
  isOrigSchedule = new HssItem("OrigSchedule");
  isEquipSub = new HssItem("EquipSub");

  constructor(index: number) {
    this.index = index;
  }
}
